import { PropsWithChildren } from 'react';
import { useProtectionLevels } from '@router/hooks';
import { ProtectionLevel } from '../types';

interface PermissionCheckProps extends PropsWithChildren {
    level: ProtectionLevel;
    fallback?: React.ReactNode;
}

export const PermissionCheck = ({
    level,
    children,
    fallback = null,
}: PermissionCheckProps) => {
    const isPermitted = useProtectionLevels(level);

    if (!isPermitted) return fallback;

    return children;
};
